import StylesService from '@/services/Styles.js'
import { tokenMethods } from "@/library/lib"

const state = {
  loading: false,
  loaded: false,
  styles: []
}

const getters = {
  styles: ({styles}) => styles,
}

const actions = {
  init: ({state, commit}) => {
    if (localStorage.getItem('fotty_token')) {
      tokenMethods.setToken(localStorage.getItem('fotty_token'), async () => {
        if (state.length) return
        commit('STYLES_REQUEST')
        try {
          const result = await StylesService.get()
          commit('SET_STYLES', result.data)
        } catch (e) {
          commit('STYLES_ERROR')
        }
      })
    }
  },
}

const mutations = {
  STYLES_REQUEST: (state) => {
    state.loading = true
    state.styles = []
    state.total = 0
  },

  SET_STYLES: (state, data) => {
    state.loading = false
    state.loaded = true
    state.styles = data
  },

  STYLES_ERROR: (state) => {
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
